import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PortalSettingsService } from '@core/services/portal-settings.service';
import { EventService } from '@core/services/event.service';
import { HomeService } from '@pages/home/services/home.service';
import { UtilityService } from '@core/services/utility.service';
import { TranslationService } from '@core/services/translation.service';
import { Subscription } from 'rxjs';
import { OnboardingStateData } from '@shared/model/onboarding-event.model';

@Component({
    selector: 'app-onboarding-layout',
    templateUrl: './onboarding-layout.component.html',
    styleUrls: ['./onboarding-layout.component.css'],
    standalone: false
})
export class OnboardingLayoutComponent implements OnInit, OnDestroy {
  private readonly portalSettings = inject(PortalSettingsService).getPortalSettings();
  private readonly utilityService = inject(UtilityService);
  private readonly homeService = inject(HomeService);
  private readonly eventService = inject(EventService);
  private readonly translationService = inject(TranslationService);
  showLanguageButton = this.portalSettings.QATestForLokalise.ConfigValue == "1";

  @ViewChild('logout') logoutNav: ElementRef<HTMLAnchorElement>;
  isSafari = false;
  isMobileIos: any;
  showLogout = false;
  showAT = false;
  showON = false;
  oNLogoCo: number;
  portalName: string;
  logoUrl: string;
  isExternalJobsiteBrowseJobs = false;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.oNLogoCo = this.portalSettings.OnboardingLogoCo.ConfigValue != null ? parseInt(this.portalSettings.OnboardingLogoCo.ConfigValue) : null;
    this.isSafari = this.utilityService.checkSafari();
    this.isMobileIos = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 7_|OS 8_|OS 9_|OS 10_|OS 11_|OS 12_\d)/i);
    if (this.isMobileIos != null && this.isSafari) {
      $('#NavBar').addClass('mobileSafari');
    }
    const locationPathName = window.location.pathname.toLowerCase();
    if (
      locationPathName.indexOf('welcome') > -1 ||
      locationPathName.indexOf('browsejobs') > 0 ||
      locationPathName.indexOf('jobdetails') > 0
    ) {
      this.logoUrl = '/Company/GetLogo?co=' + this.oNLogoCo + '&size=S';
      this.getPortalName();
    }
    if (locationPathName.indexOf('welcome') == -1) {
      this.showLogout = true;
    }
    if (locationPathName.indexOf('browsejobs') > 0 || locationPathName.indexOf('jobdetails') > 0) {
      this.isExternalJobsiteBrowseJobs = true;
    }
    this.subscriptions.push(this.eventService.on('ISAT', (event: { data: OnboardingStateData }) => this.ISAT(event.data)));
    this.subscriptions.push(this.eventService.on('ISON', (event: { data: OnboardingStateData }) => this.ISON(event.data)));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }

  private ISAT(data?: OnboardingStateData) {
    this.showAT = true;
    setTimeout(() => {
      this.logoutNav.nativeElement.addEventListener('click', event => {
        event.preventDefault();
        this.utilityService.isLoggedOut = true;
        window.location.href = this.logoutNav.nativeElement.href;
      });
    });
    this.showON = false;
    this.getLogoForCompany(data?.company);
  }

  private ISON(data?: OnboardingStateData) {
    this.showAT = false;
    this.showON = true;
    this.getLogoForCompany(data?.company);
  }

  private getLogoForCompany(profileCompany?: number ) {
    const logoCompany = (profileCompany === -1 || profileCompany == null) ? this.oNLogoCo : profileCompany;
    if (logoCompany != null) {
      this.logoUrl = '/Company/GetLogo?co=' + logoCompany + '&size=S';
      this.getPortalName(logoCompany);
    }
  }

  private getPortalName(co?: number) {
    this.homeService.getPortalName(co ?? this.oNLogoCo).then(response => {
      this.portalName = response == '' ? null : response;
    });
  }

  get languageList() {
    return this.translationService.availableLanguage();
  }

  get selectedLanguage() {
    return this.translationService.currentLanguage();
  }

  set selectedLanguage(langObj) {
    this.translationService.setCurrentLanguage(langObj.Code);
  }
}
